import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import Footer from "../components/Footer";
import Contact from "../components/Contact";

const EpcAdvisoryPage = () => {
    return (
        <Layout pageTitle="HiTech | Cố vấn quản trị EPC">
            <NavOne />
            <Contact />
            <Footer />
        </Layout>
    );
};

export default EpcAdvisoryPage;
